(function () {

	'use strict';


	let cologicCustomKontakt = {




		formok: true,


		setKontakt: async function () {

			let that = this;
			$('.valCheck').bind('input', function () {
				that.validateTextField($(this), $(this).val());
			}).bind('change', function () {
				that.validateTextField($(this), $(this).val());
			});
                $('.sprache').each(function () {

                    let languageInput = degpt.getOptions('DE');
                    let seVals = '';
                    $.each(languageInput.languages, function(i, val) {
                        seVals+='<option value="'+val.key+'">'+val.value+'</option>';
                    });
                    $(this).html(seVals);
                });

                $('.patientengruppen').each(function () {
                    let patientgroupInput = degpt.getOptions('DE');
                    let seVals = '';
                    $.each(patientgroupInput.patientGroups, function(i, val) {
                        seVals+='<option value="'+val.key+'">'+val.value+'</option>';
                    });
                    $(this).html(seVals);
                });

            $('.land').each(function () {
                let id = $(this).parent().parent().attr('id');
                let country = $(this).val();
				that.setupSearchSpecials(country, id);
			}).bind('change', function () {
                let id = $(this).parent().parent().attr('id');
                let country = $(this).val();
                that.setupSearchSpecials(country, id);
			});


                $('.acbo-head-inner').bind('click', function () {
                    $(this).next('.acbo-body-inner').find('#formConfig').each(function(){
                        let _id = $(this).parent().attr('id');

                        that.sendForm(_id);
                    });
            });



			// $('.siteUrl').val(window.location);

		},

        setupSearchSpecials: function (country, id) {
            let countryInput =  degpt.getOptions(country);
            $('#'+id).find('.therapieverfahren').each(function() {
                let seVals = '';
                $.each(countryInput.methods, function(i, val) {
                    seVals+='<option value="'+val.key+'">'+val.value+'</option>';
                });
                if(seVals != ''){
                    $(this).parent().show();
                    $(this).html(seVals);
                }else{
                    $(this).parent().hide();
                }
            });
            $('#'+id).find('.abrechnung').each(function() {
                let seVals = '';
                $.each(countryInput.billing, function(i, val) {
                    seVals+='<option value="'+val.key+'">'+val.value+'</option>';

                    // seVals+='<div class="checkInner">' +
                    //     '<input class="" data-name="'+val.key+'" id="'+val.key+'" name="abrechnung" type="checkbox">' +
                    //     '<label class="fg-mainDark" for="'+val.key+'">'+val.value+'</label>' +
                    //     '</div>';
                });
                if(seVals != ''){
                    $(this).parent().show();
                    $(this).html(seVals);
                }else{
                    $(this).parent().parent().hide();

                }
            });
            // $.each(countryInput.billing, function(i, val) {
            //     formData.append(val.name, val.value);
            // });

        },

		configSelect: function (tempArray, id, formid) {
            let seVals = '';
            $.each( tempArray, function( value, description ) {
                // if(item!=undefined && item!=' '  && item !=''  && item!=null ){
                    seVals+='<option value="'+value+'">'+description+'</option>';
                // }
            });
            $.each( tempArray, function( value, description ) {
                // if(item!=undefined && item!=' '  && item !=''  && item!=null ){
                    seVals+='<div class="checkInner">' +
                                '<input class="" data-name="'+value+'" id="'+value+'" name="abrechnung" type="checkbox">' +
                                '<label class="fg-mainDark" for="selbst">'+description+'</label>' +
                              '</div>';
            });
            $(_elem).html(seVals);

        },

        // Validierung

        validateTextField: function (_elem, _val) {

			let that = this;
			if($(_elem).prop('required') || $(_elem).val() !== '' ) {

				switch ($(_elem).attr('id')) {
					case 'vorname' :
					case 'nachname' :
					case 'firma' :
						if (_val.length > 2) {
							if (that.validateText(_val)) {
								if (!$(_elem).hasClass('fgBlack')) {
									$(_elem).addClass('fgBlack validatedBorder').removeClass("error");
								}
							} else {
								if ($(_elem).hasClass('fgBlack')) {
									$(_elem).removeClass('fgBlack validatedBorder').addClass('error');
								}
								that.formok = false

							}
						} else {
							if ($(_elem).hasClass('fgBlack')) {
								$(_elem).removeClass('fgBlack validatedBorder').addClass('error');
							}
							that.formok = false

						}

						break;

					case 'anrede' :
					case 'betreff' :
						if (_val) {
							if (!$(_elem).hasClass('fgBlack')) {
								$(_elem).addClass('fgBlack validatedBorder').removeClass("error");
							}
						} else {
							if ($(_elem).hasClass('fgBlack')) {
								$(_elem).removeClass('fgBlack validatedBorder').addClass('error');
							}
							that.formok = false

						}

						break;

					case 'nachricht' :
						if (_val.length > 2) {
							if (that.validateMessage(_val)) {
								if (!$(_elem).hasClass('fgBlack')) {
									$(_elem).addClass('fgBlack validatedBorder').removeClass("error");
								}
							} else {
								if ($(_elem).hasClass('fgBlack')) {
									$(_elem).removeClass('fgBlack validatedBorder').addClass('error');
								}
								that.formok = false

							}
						} else {
							if ($(_elem).hasClass('fgBlack')) {
								$(_elem).removeClass('fgBlack validatedBorder').addClass('error');
							}
							that.formok = false

						}

						break;

					case 'telefon' :
					case 'telefonPopup' :
						if (_val.length > 4) {
							if (that.validatePhone(_val)) {
								if (!$(_elem).hasClass('fgBlack')) {
									$(_elem).addClass('fgBlack validatedBorder').removeClass("error");
								}
							} else {
								if ($(_elem).hasClass('fgBlack')) {
									$(_elem).removeClass('fgBlack validatedBorder').addClass('error');
								}
								that.formok = false

							}
						} else {
							if ($(_elem).hasClass('fgBlack')) {
								$(_elem).removeClass('fgBlack validatedBorder').addClass('error');
							}
							that.formok = false

						}

						break;

					case 'plz' :
						if (_val.length > 1) {
							if (that.validatePlz(_val)) {
								if (!$(_elem).hasClass('fgBlack')) {
									$(_elem).addClass('fgBlack validatedBorder').removeClass("error");
								}
							} else {
								if ($(_elem).hasClass('fgBlack')) {
									$(_elem).removeClass('fgBlack validatedBorder').addClass('error');
								}
								that.formok = false

							}
						} else {
							if ($(_elem).hasClass('fgBlack')) {
								$(_elem).removeClass('fgBlack validatedBorder').addClass('error');
							}
							that.formok = false

						}

						break;

					case 'email' :
						if (_val.length > 5) {
							if (that.validateEmail(_val)) {
								if (!$(_elem).hasClass('fgBlack')) {
									$(_elem).addClass('fgBlack validatedBorder').removeClass("error");
								}

							} else {
								if ($(_elem).hasClass('fgBlack')) {
									$(_elem).removeClass('fgBlack validatedBorder').addClass('error');
								}
								that.formok = false

							}
						} else {
							if ($(_elem).hasClass('fgBlack')) {
								$(_elem).removeClass('fgBlack validatedBorder').addClass('error');
							}
							that.formok = false

						}

						break;

					case 'fileInput1' :
						if (_val.length > 0) {
							if (_val.endsWith('.pdf') || _val.endsWith('.doc') || _val.endsWith('.docx') || _val.endsWith('.txt')) {
								if (!$(_elem).parent().find('span').hasClass('fgBlack')) {
									$(_elem).parent().find('span').addClass('fgBlack validatedBorder').removeClass("error");
								}

							} else {
								if ($(_elem).parent().find('span').hasClass('fgBlack')) {
									$(_elem).parent().find('span').removeClass('fgBlack validatedBorder').addClass('error');
								}
								that.formok = false

							}
						} else {
							if ($(_elem).parent().find('span').hasClass('fgBlack')) {
								$(_elem).parent().find('span').removeClass('fgBlack validatedBorder').addClass('error');
							}
							that.formok = false

						}

						break;

				}

			}

		},


		// Text validieren
		validateText: function ($text) {
			let textReg = /^[a-zA-ZäöüÄÖÜß0-9.,_\-&/+ ']{2,50}$/;
			return textReg.test( $text );
		},

		// Textarea validieren
		validateMessage: function ($text) {
			let messageReg = /^[a-zA-ZäöüÄÖÜß0-9.,;:!?()%$§€@_#*"´`\-&/+ '\r\n\t]{2,}$/;
			return messageReg.test( $text );
		},

		// PLZ validieren
		validatePlz: function ($plz) {
            let plzReg = /^[0-9]{2,8}$/;
            return plzReg.test( $plz );
            },

		// Telefon validieren
		validatePhone: function ($phone) {
			let phoneReg = /^[0-9\-/+ ']{4,30}$/;
			return phoneReg.test( $phone );
		},

		// E-Mail validieren
		validateEmail: function ($email) {
			let emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
			return emailReg.test( $email );
		},


		// Error & Required Check

		finalFormCheck: function (formId, elem = '') {

			let that = this;

			that.formok=true;

			$('#'+formId+' .valCheck').each(function(){
				if($(this).prop('required')){
					that.validateTextField( $(this), $(this).val() );
				}
			});

            $('#'+formId+' .confirmation').each(function(){
                that.dataProtectConfirm( $(this) );
            });



			$('#'+formId+' .confirmation').each(function(){
				that.dataProtectConfirm( $(this) );
			});
            if (that.formok) {
                // if (!$(_elem).data('isclicked')) {

                that.sendForm(formId);
                    that.scrollToId(formId);
                    // $(_elem).data('isclicked', true);
                    // setTimeout(function () {
                    //     $(_elem).removeData('isclicked');
                    // }, 5000);
                // }


            } else {

                $('.errorFeedBack').css('visibility', 'visible');
            }

		},

        // scrollToY: function (_y) {
        //     $('html, body').animate({scrollTop: _y}, '200');
        // },
        // scrollToId: function (_id) {
        //     let offSet = $('#headerMain').innerHeight();
        //     console.log('inScroll'+_id);
        //     this.scrollToY($('#' + _id).offset().top - (offSet + 50));
        // },

		checkFormFiled: function (_id) {

			if ( !$('#'+_id ).hasClass('fgBlack') ){
				$('#'+_id ).addClass('error')
				this.formok = false
			}

		},


		dataProtectConfirm: function (_elem) {

			if(!$(_elem).prop('checked')){
				$(_elem).parent().find('label').addClass('error');
				this.formok = false;
			}else{
				$(_elem).parent().find('label').removeClass('error');
			}
		},


		sendForm: async function (_id) {
            if( _id == 'kontaktform-standard' ){
                $('#'+_id).addClass('busyForm');
                let that = this;
                $('#' + _id + ' .errorFeedBack').hide();

                let inVals;

                let form = document.forms.namedItem(_id);
                inVals = new FormData(form);
                	this.queryMailandler(false, inVals, function (response_Data) {
                		if (response_Data) {
                            $('#'+_id).removeClass('busyForm');

                            $('#' + _id + ' .contactResponse').removeClass('inactive');

                		} else {
                            $('#'+_id).removeClass('busyForm');

                            $('#' + _id + ' .contactResponseFailed').removeClass('inactive');
                		}

                	});

             }else{

            $('#'+_id).on('keyup keypress', function(e) {
                var keyCode = e.keyCode || e.which;
                if (keyCode === 13) {
                    e.preventDefault();
                    return false;
                }
            });
            $('#'+_id).addClass('busyForm');
            let that = this;
            $('#' + _id + ' .errorFeedBack').hide();

            let inVals;
            let htmlCode = '';
            let form = document.forms.namedItem(_id);
            inVals = new FormData(form);
            if (inVals.get('formConfig')) {
                switch (inVals.get('formConfig')) {
                    case 'h12':
                        htmlCode = await degpt.renderEntities({
                            textFilter: inVals.get('suche'),
                            entityTypeId: [ConstService.ENTITY_TYPE_MEMBER],
                            countryCode: "AT",
                            qualificationType: ConstService.QUALIFICATION_KLIN_GESUNDH
                        }, false);
                        break;
                    case 'h13':
                        htmlCode = await degpt.renderEntities({
                            textFilter: inVals.get('suche'),
                            entityTypeId: [ConstService.ENTITY_TYPE_MEMBER],
                            qualificationType: ConstService.QUALIFICATION_TRAUMA_PAED
                        }, false);
                        break;
                    case 'h14':
                        htmlCode = await degpt.renderEntities({
                            textFilter: inVals.get('suche'),
                            entityTypeId: [ConstService.ENTITY_TYPE_MEMBER],
                            qualificationType: ConstService.QUALIFICATION_DEGPT_SOZ_ENTSCH,
                        }, false);
                        break;
                    case 'h15':
                        htmlCode = await degpt.renderEntities({
                            textFilter: inVals.get('suche'),
                            entityTypeId: [ConstService.ENTITY_TYPE_MEMBER],
                            qualificationType: ConstService.QUALIFICATION_DEGPT_AUFENTH,
                        }, false);
                        break;
                    case 'h16':
                        htmlCode = await degpt.renderEntities({
                            textFilter: inVals.get('suche'),
                            entityTypeId: [ConstService.ENTITY_TYPE_INSTITUTE],
                            propertyType: ConstService.PROPERTY_TYPE_WEITERBILDUNGSINSTITUT_DEGPT_SPEZ_PTT_ERW
                        }, false);
                        break;
                    case 'h17':
                        htmlCode = await degpt.renderEntities({
                            textFilter: inVals.get('suche'),
                            entityTypeId: [ConstService.ENTITY_TYPE_INSTITUTE],
                            propertyType: ConstService.PROPERTY_TYPE_WEITERBILDUNGSINSTITUT_DEGPT_SPEZ_PTT_KJ
                        }, false);
                        break;
                    case 'h18':
                        htmlCode = await degpt.renderEntities({
                            textFilter: inVals.get('suche'),
                            entityTypeId: [ConstService.ENTITY_TYPE_INSTITUTE],
                            propertyType: ConstService.PROPERTY_TYPE_WEITERBILDUNGSINSTITUT_TRAUMAPAED_TRAUMAZENTR_FB
                        }, false);
                        break;
                }
            }else if(_id == 'kontaktform-newsletter' ) {
                await degpt.addNewsletterRecipient(inVals.get('email'));
            } else {
                htmlCode = await degpt.renderEntities({
                    textFilter: inVals.get('suche'),
                    entityTypeId: [ConstService.ENTITY_TYPE_MEMBER],
                    countryCode: inVals.get('land'),
                    areaCode: inVals.get('plz'),
                    billingType: inVals.get('abrechnung'),
                    languageCode: inVals.get('sprache'),
                    therapyMethod: inVals.get('therapieverfahren'),
                    radiusKilometer: inVals.get('umkreis'),
                    patientGroup: inVals.get('patientengruppen'),
                    gender: inVals.get('gender')
                }, true);
            }
            if(_id != 'kontaktform-newsletter' ) {
                let suche = '';
                if ($('#' + _id + ' #suche').length < 1) {
                    suche = '<div class="form-col">' +
                        '<label for="suche" class="labelStd">Suche</label>' +
                        '<input class="textfeld valCheck fgBlack suche" data-name="suche" id="suche" maxLength="256"name="suche" >' +
                        '</div>' +
                        '<div class="form-col-btn">' +
                        '<p class="BTN" onclick="cologic.finalFormCheck(\'' + _id + '\');">Suchen</p>' +
                        '</div>';

                    // $('#' + _id).append(suche);

                }
                $('#' + _id + ' .contactResponseSearch').html(htmlCode).before(suche);
                let count = 0;
                $('#' + _id + ' .contactResponseSearch tbody tr').each(function () {
                    if ($(this).attr('class') !== undefined) {
                        count++;
                        if (count % 4 == 0) {
                            $(this).addClass('vier');
                            count = 0;
                        } else if (count % 3 == 0) {
                            $(this).addClass('drei');
                        } else if (count % 2 == 0) {
                            $(this).addClass('zwei');
                        } else {
                            $(this).addClass('eins');
                        }
                    }
                });
            }
            $('#'+_id).removeClass('busyForm');


            that.scrollToId(('result-'+_id));
            // $('#' + _id + ' #suche').bind('input', function(){
            //     console.log('sendform init 1');
            //
            //     // let _val = $(this).val();
            //     that.sendForm(_id);
            // });
            // if (_id.indexOf('job') !== -1) {
            // 	this.queryMailandler(false, inVals, function (response_Data) {
            // 		if (response_Data) {
            // 			$('#' + _id + ' .contactResponse').removeClass('inactive');
            // 			let tempFormDiv = '<div id="tempFormDiv"></div>';
            // 			$('body').append(tempFormDiv);
            // 			$('#tempFormDiv').css({'background-image': 'url("fileadmin/casla-job.jpg")'});
            // 			$('#tempFormDiv').css({'width': '0', 'height': '0'});
            //
            // 		} else {
            // 			$('#' + _id + ' .contactResponseFailed').removeClass('inactive');
            //
            //
            // 		}
            //
            // 	});
            // } else {
            // 	this.queryMailandler(false, inVals, function (response_Data) {
            // 		if (response_Data) {
            // 			$('#' + _id + ' .contactResponse').removeClass('inactive');
            // 			let tempFormDiv = '<div id="tempFormDiv"></div>';
            // 			$('body').append(tempFormDiv);
            // 			$('#tempFormDiv').css({'background-image': 'url("fileadmin/casla-lead.jpg")'});
            // 			$('#tempFormDiv').css({'width': '0', 'height': '0'});
            //
            // 		} else {
            // 			$('#' + _id + ' .contactResponseFailed').removeClass('inactive');
            //
            //
            // 		}
            //
            // 	});
            // }
            }

        },

        closeResponse: function () {
            $('.contactResponse').addClass('inactive');
            $('.overlay-container').addClass('hide');
        },

        closeResponseFailed: function () {
            $('.contactResponseFailed').addClass('inactive');
            $('.overlay-container').addClass('hide');
        },


        //------------------------------

        /*********** Ajax DB Abfragen Start ******************/


        queryMailandler: function (handleAsJson, _params, ajaxCallback) {
            // let trgAdress = this.mailHandlerURL;
            let trgAdress = document.getElementsByTagName('base')[0].href + "mailaction";

                $.ajax({
                type: 'post',
                cache: false,
                data: _params,
                url: trgAdress,
                processData: false,
                contentType: false

            })
                .done(function (data) {
                    try {
                        let response;
                        //remove BOM + parse json
                        if (handleAsJson) {
                            response = $.parseJSON(data.trim());
                        } else {
                            response = data.trim();
                        }

                        if (ajaxCallback)
                            ajaxCallback(response);
                        return (response);

                    } catch (err) {
                        alert("Fehler: " + err);
                    }
                })
                .fail(function (err) {
                    alert("Es ist ein Fehler aufgetreten: " + err);
                });
        },

        showFilename: function (e) {
            $(e).prev('span').html($(e)[0].files[0].name);
        }

    }

	//------------------------------------

	//gemeinsam verfügbar machen
	if (typeof (cologic) === 'undefined')
		window.cologic = {};
	$.extend(cologic, cologicCustomKontakt);
}());